import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20.177 40.842v-7.974h1.462a4.4 4.4 0 0 1 1.897.426l13.553 6.42a2.66 2.66 0 0 0 3.782-2.127c.38-3.667.57-8.781.57-15.352q0-9.853-.57-15.351a2.656 2.656 0 0 0-3.782-2.128l-13.553 6.42a4.4 4.4 0 0 1-1.897.427h-5.88a9.746 9.746 0 0 0-9.742 9.467A59 59 0 0 0 6 22.229c.004.518.01.904.017 1.172a9.74 9.74 0 0 0 4.513 7.946l2.368 9.896a2.66 2.66 0 0 0 2.628 2.257h1.992a2.66 2.66 0 0 0 2.659-2.658m4.117-9.15a6.2 6.2 0 0 0-2.346-.589V13.367c.812-.04 1.61-.24 2.346-.589l13.553-6.42a.886.886 0 0 1 1.26.71c.374 3.594.562 8.653.562 15.167 0 6.515-.188 11.574-.561 15.168a.886.886 0 0 1-1.26.71zM20.176 13.38v17.716H15.76a7.974 7.974 0 0 1-7.97-7.746 58 58 0 0 1-.017-1.121c.003-.48.009-.855.016-1.108a7.974 7.974 0 0 1 7.971-7.746h4.417zm-1.771 27.462v-7.974H15.76a9.7 9.7 0 0 1-3.17-.528l2.041 8.53.017.089c.058.44.434.769.878.769h1.993a.886.886 0 0 0 .886-.886",
      clipRule: "evenodd"
    }
  )
);
var SvgFeedbackOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FeedbackOutlined_default = SvgFeedbackOutlined;

export { FeedbackOutlined_default as default };
